import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_EVENT } from "src/constants/mutations";
import { failureToast, successToast } from "src/utils/toasts";
import { UpdateEventInput } from "src/interfaces/event.interface";
import { update_event } from "src/store/features/events-slice";

export const useUpdateEvent = () => {
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();
  
  const [isUpdatingEvent, setIsUpdatingEvent] = useState(false);

  const updateEventMutation = useCallback(
    async (updateEventInput: UpdateEventInput): Promise<boolean> => {
      setIsUpdatingEvent(true);

      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: UPDATE_EVENT,
          variables: {
            updateEventInput,
          },
        });

        // Check for GraphQL errors
        if (data?.errors && data.errors.length > 0) {
          const errorMessage = data.errors[0]?.message || "Failed to update event";
          console.error("GraphQL error:", errorMessage);
          failureToast(errorMessage);
          return false;
        }

        if (data?.data?.updateEvent) {
          dispatch(update_event(data.data.updateEvent));
          successToast("Event has been updated successfully!");
          return true;
        }
        console.error("No event data returned from mutation");
        failureToast("Failed to update event: No data returned");
        return false;
      } catch (err: any) {
        console.error("Error updating event:", err);
        const errorMessage = err?.response?.data?.errors?.[0]?.message || err?.message || "Failed to update event";
        failureToast(errorMessage);
        return false;
      } finally {
        setIsUpdatingEvent(false);
      }
    },
    [axBe, dispatch]
  );

  return {
    isUpdatingEvent,
    updateEvent: updateEventMutation,
  };
};

